/**
 * 巡检管理（inspectionManagement）模块英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/inspectionManagement/ 第 4 组：inspectionPlanRevenue /
 *          inspectionPlanWaterWorks（巡检计划 Revenue、水厂变体）、inspectionTeam、
 *          lineManagement、meterAreaList、taskManagement（含 Outsourcing 变体）
 * 术语：巡检=Inspection，巡检计划=Inspection Plan，巡检任务=Inspection Task，
 *       管线=Pipeline，水厂=Water Plant，营收=Revenue，班组=Team
 */
export default {
  '上级区域': 'Parent Area',
  '下载': 'Download',
  '不支持复制': 'Copy Not Supported',
  '临时任务': 'Temporary Task',
  '任务分派': 'Task Assignment',
  '任务分配人员名称': 'Assigner Name',
  '任务单号': 'Task No.',
  '任务名称': 'Task Name',
  '任务实施人员名称': 'Implementer Name',
  '任务状态': 'Task Status',
  '任务类型': 'Task Type',
  '任务结束时间': 'Task End Time',
  '保存': 'Save',
  '保存成功!': 'Saved successfully!',
  '停用': 'Disable',
  '停用成功': 'Disabled successfully',
  '全部勾选': 'Check All',
  '关闭更新内容': 'Close Update Content',
  '其他指标': 'Other Indicators',
  '分派': 'Assign',
  '删除多条数据': 'Delete multiple records',
  '删除成功!': 'Deleted successfully!',
  '刷新': 'Refresh',
  '区域': 'Area',
  '区域ID': 'Area ID',
  '区域名称': 'Area Name',
  '区域编码': 'Area Code',
  '历史记录': 'History',
  '取消全选': 'Uncheck All',
  '取消关联': 'Unlink',
  '取消选择': 'Deselect',
  '合并所有': 'Collapse All',
  '启用': 'Enabled',
  '启用成功': 'Enabled successfully',
  '启用时间': 'Activation Time',
  '周期': 'Cycle',
  '地图展示': 'Map View',
  '基本信息': 'Basic Information',
  '复制': 'Copy',
  '复制成功': 'Copied successfully',
  '外围': 'External',
  '完成': 'Finish',
  '实施人员': 'Implementer',
  '实施人类型': 'Implementer Type',
  '导入': 'Import',
  '导出': 'Export',
  '展开': 'Expand',
  '展开所有': 'Expand All',
  '巡检任务': 'Inspection Task',
  '巡检任务信息': 'Inspection Task Information',
  '巡检任务页面': 'Inspection Task Page',
  '巡检区域': 'Inspection Area',
  '巡检历史记录': 'Inspection History',
  '巡检方式': 'Inspection Method',
  '巡检状态': 'Inspection Status',
  '巡检班组': 'Inspection Team',
  '巡检线路': 'Inspection Route',
  '巡检结果': 'Inspection Result',
  '巡检结果页面': 'Inspection Result Page',
  '巡检要求': 'Inspection Requirements',
  '巡检计划': 'Inspection Plan',
  '巡检计划信息': 'Inspection Plan Info',
  '巡检计划页面': 'Inspection Plan Page',
  '巡检路线': 'Inspection Route',
  '已分配': 'Assigned',
  '已启用': 'Enabled',
  '已完成': 'Completed',
  '开始时间': 'Start Time',
  '异常': 'Abnormal',
  '当前选择：': 'Currently selected:',
  '成员': 'Member',
  '手机号': 'Mobile Phone',
  '打开更新内容': 'Open Update Content',
  '执行人员': 'Executor',
  '执行人员(班组/成员)': 'Executor (Team/Member)',
  '执行人员类型': 'Executor Type',
  '批量删除': 'Batch Delete',
  '指定班组': 'Assign Team',
  '换表': 'Meter Replacement',
  '排序': 'Sort Order',
  '操作人': 'Operated By',
  '操作时间': 'Operation Time',
  '收起': 'Collapse',
  '数据列表': 'Data List',
  '无': 'None',
  '无图片': 'No Image',
  '无文件': 'No File',
  '日常任务': 'Routine Task',
  '是否反馈': 'Feedback or Not',
  '是否存在问题': 'Problem or Not',
  '是否常规': 'Routine or Not',
  '是否正常': 'Normal or Not',
  '是否自动分派': 'Auto Assignment',
  '更新任务': 'Update Task',
  '更新时间': 'Updated At',
  '更新设备状态': 'Update Device Status',
  '未分配': 'Unassigned',
  '未启用': 'Not Enabled',
  '未完成': 'Unfinished',
  '未开始': 'Not Started',
  '来源': 'Source',
  '查漏专项': 'Leak Detection Special',
  '查询结束时间': 'End time',
  '查询起始时间': 'Start time',
  '检测内容': 'Check Content',
  '检测实体': 'Detected Entity',
  '检测类型': 'Check Type',
  '检测编号': 'Check No.',
  '正常': 'Normal',
  '步巡': 'Foot Patrol',
  '水厂': 'Water Plant',
  '水表': 'Water Meter',
  '测点实体': 'Monitoring Point Entity',
  '添加': 'Add',
  '添加下级': 'Add Child',
  '添加区域': 'Add Area',
  '添加成功': 'Added successfully',
  '添加设备': 'Add Device',
  '添加设备超出设备数': 'The number of devices exceeds the limit',
  '父子关联': 'Parent-Child Link',
  '状态': 'Status',
  '班组': 'Team',
  '班组介绍': 'Team Introduction',
  '班组名称': 'Team Name',
  '直接指定实施人员': 'Assign Implementer Directly',
  '确定停用吗?': 'Are you sure to disable?',
  '确定启用吗?': 'Are you sure to enable?',
  '确定结束吗?': 'Are you sure to end?',
  '确定要删除此区域{name}以及子节点数据吗?': 'Are you sure to delete area {name} and all its child nodes?',
  '确认删除': 'Confirm Deletion',
  '第一个设备类型': 'Device Type 1',
  '第三个设备类型': 'Device Type 3',
  '第二个设备类型': 'Device Type 2',
  '管线': 'Pipeline',
  '管网': 'Pipe Network',
  '线路管理页面': 'Route Management Page',
  '组员姓名': 'Team Member Name',
  '组员电话': 'Team Member Phone',
  '组员选择': 'Select Team Members',
  '组长名称': 'Team Leader Name',
  '组长联系方式': 'Team Leader Contact',
  '结束': 'Finished',
  '结束时间': 'End Time',
  '结果描述': 'Result Description',
  '营收': 'Revenue',
  '解决前照片或视频': 'Photos/Videos Before Resolution',
  '解决后照片或视频': 'Photos/Videos After Resolution',
  '计划区域': 'Plan Area',
  '计划名称': 'Plan Name',
  '计划周期': 'Plan Cycle',
  '计划状态': 'Plan Status',
  '计划类别': 'Plan Category',
  '计划类型': 'Plan Type',
  '设备': 'Device',
  '设备名称': 'Device Name',
  '设备名称：': 'Device Name: ',
  '设备状态': 'Device Status',
  '设备类型': 'Device Type',
  '设备类型：': 'Device Type: ',
  '设备纬度': 'Device Latitude',
  '设备纬度：': 'Device Latitude: ',
  '设备经度': 'Device Longitude',
  '设备经度：': 'Device Longitude: ',
  '设备编号': 'Device No.',
  '设备编号：': 'Device No.: ',
  '请先点击选中上级区域！': 'Please select a parent area first!',
  '请先选择一个区域!': 'Please select an area first!',
  '请点击选择要修改区域!': 'Please click to select the area to modify!',
  '请输入事务分类': 'Please enter transaction category',
  '请输入任务名称': 'Please enter task name',
  '请输入其他指标': 'Please enter other indicators',
  '请输入创建时间': 'Please enter creation time',
  '请输入区域/小区名称': 'Please enter area/community name',
  '请输入区域/小区名称!': 'Please enter the area/community name!',
  '请输入区域名称': 'Please enter area name',
  '请输入区域编码': 'Please enter area code',
  '请输入周期值': 'Please enter cycle value',
  '请输入地理信息': 'Please enter geographic info',
  '请输入备注信息': 'Please enter remark',
  '请输入巡检方案名称': 'Please enter inspection plan name',
  '请输入巡检要求': 'Please enter inspection requirements',
  '请输入工单联系人': 'Please enter work order contact',
  '请输入开始时间': 'Please enter start time',
  '请输入检测内容': 'Please enter check content',
  '请输入检测实体': 'Please enter detected entity',
  '请输入检测类型': 'Please enter check type',
  '请输入检测编号': 'Please enter check number',
  '请输入状态': 'Please enter status',
  '请输入班组介绍': 'Please enter team description',
  '请输入班组名称': 'Please enter team name',
  '请输入紧急程度': 'Please enter urgency level',
  '请输入线路名称': 'Please enter route name',
  '请输入组长联系方式': 'Please enter team leader contact',
  '请输入结束时间': 'Please enter end time',
  '请输入结果描述': 'Please enter result description',
  '请输入联系电话': 'Please enter contact phone',
  '请输入计划区域': 'Please enter plan area',
  '请输入计划名称': 'Please enter plan name',
  '请输入计划类型': 'Please enter plan type',
  '请输入设备名称': 'Please enter device name',
  '请输入负责人!': 'Please enter the person in charge!',
  '请输入负责人名称': 'Please enter person in charge name',
  '请输入负责人手机号': 'Please enter person in charge mobile phone',
  '请输入路线名称': 'Please enter route name',
  '请输入路线类型': 'Please enter route type',
  '请输入里程数': 'Please enter mileage',
  '请输入里程数(Km)': 'Please enter mileage (km)',
  '请选择人员': 'Please select personnel',
  '请选择任务状态': 'Please select task status',
  '请选择任务类型': 'Please select task type',
  '请选择区域': 'Please select area',
  '请选择区域名称': 'Please select area name',
  '请选择启用时间': 'Please select activation time',
  '请选择周期类型': 'Please select cycle type',
  '请选择实施人类型': 'Please select implementer type',
  '请选择巡检任务': 'Please select inspection task',
  '请选择巡检方式': 'Please select inspection method',
  '请选择巡检计划': 'Please select inspection plan',
  '请选择工单类型': 'Please select work order type',
  '请选择开始时间': 'Please select start time',
  '请选择截止时间': 'Please select deadline',
  '请选择执行人员(成员)': 'Please select executor (member)',
  '请选择执行人员(班组)': 'Please select executor (team)',
  '请选择执行人员类型': 'Please select executor type',
  '请选择是否反馈': 'Please select whether feedback is required',
  '请选择是否常规': 'Please select whether it is routine',
  '请选择是否正常': 'Please select whether it is normal',
  '请选择是否自动分派': 'Please select whether to auto assign',
  '请选择来源': 'Please select source',
  '请选择检测类型': 'Please select check type',
  '请选择测点实体': 'Please select monitoring point entity',
  '请选择班组': 'Please select team',
  '请选择组员': 'Please select members',
  '请选择组长': 'Please select team leader',
  '请选择结束时间': 'Please select end time',
  '请选择计划类别': 'Please select plan category',
  '请选择计划类型': 'Please select plan type',
  '请选择设备': 'Please select device',
  '请选择设备是否正常': 'Please select whether the device is normal',
  '请选择设备状态': 'Please select device status',
  '请选择设备类型': 'Please select device type',
  '请选择路线': 'Please select route',
  '请选择路线状态': 'Please select route status',
  '请选择路线类型': 'Please select route type',
  '负责人': 'Person in Charge',
  '超时未完成': 'Overdue & Unfinished',
  '路线-设备信息': 'Route - Device Info',
  '路线名称': 'Route Name',
  '路线状态': 'Route Status',
  '路线类型': 'Route Type',
  '路线详情': 'Route Details',
  '路线里程数(km)': 'Route Mileage (km)',
  '车巡': 'Vehicle Patrol',
  '运行状态': 'Running Status',
  '进行中': 'In Progress',
  '选择人员': 'Select Personnel',
  '选择实施人': 'Select Implementer',
  '选择班组': 'Select Team',
  '选择设备': 'Select Device',
  '选择路线': 'Select Route',
  '选择路线类型': 'Select Route Type',
  '里程数': 'Mileage',
  '里程数(Km)': 'Mileage (km)',
  '重点区域': 'Key Area',
  '问题描述': 'Problem Description',
  '阀门': 'Valve',
  '预览': 'Preview',
}
